import * as React from "react";
import { useMemo } from "react";
import SearchPagePreferencesContext from "./SearchPagePreferencesContext";
import SearchPagePreferencesState from "./SearchPagePreferencesState";
const SearchPagePreferencesStateProvider = ({ getPreference, setPreference, children }) => {
  const searchPagePreferencesContextValue = useMemo(() => {
    const config = {
      sidebar: { isPinned: getPreference("sidebarIsPinned", false) }
    };
    const actions = { toggleSidebarPinning: () => setPreference("sidebarIsPinned", !config.sidebar.isPinned) };
    return {
      config,
      actions
    };
  }, [getPreference, setPreference]);
  return /* @__PURE__ */ React.createElement(SearchPagePreferencesContext.Provider, { value: searchPagePreferencesContextValue }, children);
};
const SearchPagePreferencesProvider = ({ children }) => /* @__PURE__ */ React.createElement(SearchPagePreferencesState, null, ({ getPreference, setPreference }) => /* @__PURE__ */ React.createElement(SearchPagePreferencesStateProvider, { getPreference, setPreference }, children));
export default SearchPagePreferencesProvider;
